import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative pt-24 pb-16 md:pt-28 md:pb-24 bg-[#1E2652]" }
const _hoisted_2 = { class: "container mx-auto px-4 md:px-6 max-w-6xl" }
const _hoisted_3 = { class: "mb-10 md:mb-14 text-center" }
const _hoisted_4 = { class: "mt-3 inline-flex items-center gap-2 rounded-full bg-white/10 text-gray-200 px-3 py-1 text-sm" }
const _hoisted_5 = { class: "grid grid-cols-1 md:grid-cols-12 gap-8" }
const _hoisted_6 = { class: "hidden md:block md:col-span-4 lg:col-span-3" }
const _hoisted_7 = { class: "sticky top-24 bg-white/5 border border-white/10 rounded-xl p-4" }
const _hoisted_8 = { class: "space-y-2" }
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "md:col-span-8 lg:col-span-9" }
const _hoisted_11 = { class: "bg-white/[0.04] border border-white/10 rounded-2xl p-6 md:p-8" }
const _hoisted_12 = ["id"]
const _hoisted_13 = ["innerHTML"]


export default /*@__PURE__*/_defineComponent({
  __name: 'LegalNotice',
  setup(__props) {

function slugifyTitle(title: string): string {
  return title
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, '')
    .trim()
    .replace(/\s+/g, '-')
}

const legalSections = [
  {
    title: '1. Éditeur du site',
    content: `
      <p>
        RAYAN MARSILE CORP<br>
        SARL AU au capital de 10 000 dirhams<br>
        Siège social : 45 avenue de France, apt 8 Agdal Rabat<br>
        Immatriculée au registre de commerce de Rabat sous le N° RC 184873<br>
        Email : contact@padelgo.ma
      </p>
    `
  },
  {
    title: '2. Hébergement',
    content: `
      <p>
        Hostinger International Ltd.<br>
        Lordou Vyrona 61, Larnaca 7550, Chypre<br>
        Serveur hébergé au Royaume-Uni<br>
        +370 645 03378
      </p>
    `
  },
  {
    title: '3. Propriété intellectuelle',
    content: `
      <p>
        L'ensemble des éléments constituant le site PadelGo (textes, graphismes, logiciels, photographies, images, vidéos, sons, plans, logos, marques, etc.) sont la propriété exclusive de PadelGo ou de ses partenaires. Toute reproduction, représentation, modification, publication, adaptation de tout ou partie des éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite, sauf autorisation écrite préalable de PadelGo.
      </p>
    `
  },
  {
    title: '4. Protection des données personnelles',
    content: `
      <p>
        Conformément à la loi 09-08 relative à la protection des personnes physiques à l'égard du traitement des données à caractère personnel, vous disposez d'un droit d'accès, de rectification et de suppression des données vous concernant. Pour exercer ce droit, vous pouvez nous contacter à l'adresse email suivante : contact@padelgo.ma
      </p>
    `
  },
  {
    title: '5. Droit applicable',
    content: `
      <p>
        Les présentes mentions légales sont soumises au droit marocain. En cas de litige, les tribunaux marocains seront seuls compétents.
      </p>
    `
  }
]

const toc = legalSections.map((s) => ({ title: s.title, slug: slugifyTitle(s.title) }))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("h1", { class: "text-3xl md:text-4xl font-bold text-white tracking-tight" }, " Mentions Légales ", -1)),
        _createElementVNode("div", _hoisted_4, [
          _cache[0] || (_cache[0] = _createElementVNode("span", { class: "h-2 w-2 rounded-full bg-[#B7E000]" }, null, -1)),
          _createElementVNode("span", null, "Dernière mise à jour : " + _toDisplayString(new Date().toLocaleDateString('fr-FR')), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("aside", _hoisted_6, [
          _createElementVNode("nav", _hoisted_7, [
            _cache[2] || (_cache[2] = _createElementVNode("h2", { class: "text-sm font-semibold text-gray-200 mb-3" }, "Sommaire", -1)),
            _createElementVNode("ul", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(toc), (item) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: item.slug
                }, [
                  _createElementVNode("a", {
                    href: '#' + item.slug,
                    class: "toc-link block text-sm text-gray-300 hover:text-white"
                  }, _toDisplayString(item.title), 9, _hoisted_9)
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("main", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(legalSections, (section, index) => {
              return _createElementVNode("section", {
                key: index,
                class: "pt-4 first:pt-0 border-t border-white/10 first:border-t-0"
              }, [
                _createElementVNode("h2", {
                  class: "text-xl md:text-2xl font-semibold text-[#B7E000] mb-3 scroll-mt-28",
                  id: _unref(toc)[index].slug
                }, _toDisplayString(section.title), 9, _hoisted_12),
                _createElementVNode("div", {
                  class: "text-gray-200 leading-relaxed space-y-4",
                  innerHTML: section.content
                }, null, 8, _hoisted_13)
              ])
            }), 64))
          ]),
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "text-center mt-10" }, [
            _createElementVNode("h3", { class: "text-lg font-semibold text-white mb-3" }, "Questions ?"),
            _createElementVNode("p", { class: "text-gray-300 mb-5" }, "Pour toute question relative à nos mentions légales, contactez-nous à :"),
            _createElementVNode("a", {
              href: "mailto:contact@padelgo.ma",
              class: "inline-flex items-center px-6 py-3 rounded-full bg-[#B7E000] text-[#1E2652] font-medium hover:bg-[#B7E000]/90 transition-colors"
            }, "contact@padelgo.ma")
          ], -1))
        ])
      ])
    ])
  ]))
}
}

})